<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="propModel" width="700">
        <div class="dialog-price">
          <div class="content-header">
            <v-icon style="font-size: 60px;">icon-SKUTRANS</v-icon>
            <h3 class="px-6">{{ item.name }}</h3>
          </div>

          <div class="content-field">
            <div class="d-flex align-items-center w-100">
              <div class="col-4 text-left">
                <span>ราคาซื้อเข้า</span>
              </div>
              <div class="col-8">
                <v-text-field
                  v-model="item.wholesale_price"
                  type="number"
                  suffix="บาท"
                  class="field-number centered-input"
                  @input="$emit('inputNumber', indexItem)"
                />
              </div>
            </div>

            <div class="d-flex align-items-center w-100">
              <div class="col-4 text-left">
                <span>ราคาขายออก</span>
              </div>
              <div class="col-8">
                <v-text-field
                  v-model="item.retail_price"
                  type="number"
                  suffix="บาท"
                  class="field-number centered-input"
                  @input="$emit('inputNumber', indexItem)"
                />
              </div>
            </div>

            <div class="d-flex align-items-center w-100">
              <div class="col-4 text-left">
                <span>สต็อกแชร์</span>
              </div>
              <div class="col-8">
                <v-text-field
                  v-model="item.stock"
                  type="number"
                  suffix="บาท"
                  class="field-number centered-input"
                  @input="$emit('inputNumber', indexItem)"
                />
              </div>
            </div>
          </div>
        </div>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['dialog', 'item', 'indexItem'],

  computed: {
    propModel: {
      get() {
        return this.dialog
      },
      set() {
        this.$emit('close', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-price {
  width: 100%;
  height: 50vh;
  background: #ffffff;
  padding: 40px 35px;
}

.content-header {
  display: flex;
}

.content-field {
  width: 100%;
  padding: 0px 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 38vh;
  max-height: 38vh;
}
</style>
